import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_learning/(deprecated)/dashboard/certificate',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/certificates',
    })
  },
})
